export const getYRange = (min, max, yFlag) => {
  // flag -> imp, ctr 구분 -> calculator 함수로 전달
  let minValue = 0
  let maxValue = 0

  if (min !== 0) {
    minValue = calculator(min, true, yFlag)
  }
  // if (!yFlag) minValue = 0
  maxValue = calculator(max, false, yFlag)
  return { min: minValue, max: maxValue }
}
export const calculator = (val, type, yFlag) => {
  // type -> min, max 구분
  if (!yFlag) {
    val *= 100
    val = val.toFixed(0)
  }
  let temp = val + ''
  let len = temp.length
  let res = temp.substr(0, 1) * 1
  let sec = temp.substr(1, 1) * 1
  if (type) { // min value
    sec = sec >= 5 ? 0.5 : 0
  } else { //  max value
    if (sec >= 5) {
      res += 1
      sec = 0
    } else {
      if (!yFlag) { // y2
        sec = sec === 0 ? 0 : (sec + 1) / 10
      } else { // y1
        sec = sec === 0 ? 0.1 : 0.5
      }
    }
  }
  for (let i = 1; i < len; i++) {
    res *= 10
    sec *= 10
  }
  res += sec

  if (!yFlag) {
    res /= 100
  }
  return res
}
export const calInterval = (interval) => {
  let temp = interval + ''
  let len = temp.length
  let res = temp.substr(0, 1) * 1
  let sec = temp.substr(1, 1) * 1
  let thir = temp.substr(2, 1) * 1
  if (thir >= 5) {
    thir = 0
    sec = (sec + 1) / 10
  } else {
    thir = 0.05
    sec /= 10
  }

  for (let i = 1; i < len; i++) {
    res *= 10
    sec *= 10
    thir *= 10
  }

  res = res + sec + thir
  return res
}
export const getAxisRange = (data) => {
  // 양쪽 Y axis value의 max, min, X axis의 catrgory, chart의 data -> data는 y axis의 interval 계산에 사용
  let imp = []
  let ctr = []
  let xCategory = []
  if (data === undefined) {
    return {
      y1Max: 0,
      y1Min: 0,
      y2Max: 0,
      y2Min: 0,
      imp,
      ctr,
      xCategory
    }
  }
  data.forEach(function (data) {
    imp.push(data.imp_cnt * 1)
    ctr.push(data.ctr * 1)
    xCategory.push(data.ymd)
  })

  let max = Math.max.apply(null, ctr) * 1.1
  max = max > 100 ? 100 : max

  return {
    y1Max: Math.max.apply(null, imp),
    y1Min: parseInt(Math.min.apply(null, imp) * 0.5),
    y2Max: max.toFixed(2),
    y2Min: Math.min.apply(null, ctr) * 0.8,
    imp,
    ctr,
    xCategory
  }
}
export const getAxisRangeVtr = (data) => {
  // 양쪽 Y axis value의 max, min, X axis의 catrgory, chart의 data -> data는 y axis의 interval 계산에 사용
  let view = []
  let vtr = []
  let endRate = []
  let xCategory = []
  data.forEach(function (cdata) {
    view.push(cdata.view_cnt * 1)
    vtr.push(cdata.vtr * 1)
    vtr.push(cdata.end_rate * 1)
    xCategory.push(cdata.ymd)
  })

  let vMax = Math.max.apply(null, vtr)
  let eMax = Math.max.apply(null, endRate)
  let max = (vMax > eMax ? vMax : eMax) * 1.1
  // max = max > 100 ? 100 : max
  return {
    y1Max: Math.max.apply(null, view),
    y1Min: parseInt(Math.min.apply(null, view) * 0.5),
    y2Max: max.toFixed(1),
    y2Min: 0,
    view,
    vtr,
    xCategory
  }
}
export const getY1Values = (min, max) => { // y axis(imp)의 interval, values 계산
  let cnt = 6
  let result = []
  let interval = 0
  if (min < 10) min = 0

  interval = (max - min) / 7
  interval = max >= 100 ? calInterval(parseInt(interval)) : interval

  let temp = min + interval
  result.push(min)
  for (let i = 0; i < cnt; i++) {
    result.push(temp)
    temp += interval
  }
  result.push(max)
  return result
}
export const getY2Values = (min, max) => { // y axis(ctr)의 interval, values 계산
  let cnt = 6
  let result = []
  let interval = ((max - min) / 7).toFixed(3) * 1

  let temp = min + interval
  result.push(min)
  for (let i = 0; i < cnt; i++) {
    result.push(temp)
    temp += interval
  }
  if (temp.toFixed(2) <= max.toFixed(2)) result.push(max)
  return result
}
export const parse = (str) => { // chart axis x format
  str = str + ''
  let m = str.substr(4, 2)
  let d = str.substr(6, 2)

  return m + '-' + d
}



// WEBPACK FOOTER //
// ./src/assets/chart/chartFunc.js